import type { FollowUpKind } from '../../../types/followUp'

export function followUpKindLabel(kind: FollowUpKind, customName?: string | null): string {
  switch (kind) {
    case 'SignDropOff': return 'Sign drop-off'
    case 'Chase': return 'Chase to vote'
    case 'CallBack': return 'Call-back'
    case 'Custom': return customName ?? 'Custom'
  }
}
